/* Identical file in Marketing & NL-CMS. If you modify this file, make the same changes there,
and vice-versa, unless changes should be specific to this project, then remove this comment. */
import { Field, useField } from 'formik';
import React, { useEffect, useState } from 'react';

interface TextFieldProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  helper?: string;
  icon?: string;
  label?: string;
  labelDescription?: string;
  maxCharCount?: number;
  name: string;
  placeholder?: string;
  pretype?: string;
  preset?: string;
  type?: string;
}

const TextField = (props: TextFieldProps) => {
  const { label, name, helper, icon, pretype } = props;
  const { labelDescription, maxCharCount, ...inputProps } = props;
  const [field, meta] = useField(name);
  const [charCount, setCharCount] = useState(field.value?.length || 0);

  useEffect(() => {
    if (maxCharCount) {
      setCharCount(field.value?.length || 0);
    }
  }, [field.value, maxCharCount]);

  return (
    <div className="TextField form-group">
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
        </label>
      )}
      {labelDescription && <div className="label-description">{labelDescription}</div>}
      <div className="forum-group-content">
        <div className={`field-container ${icon ? 'container-with-icon' : ''}`}>
          {pretype && (
            <div
              className={`pretype ${meta.touched && meta.error ? 'is-invalid' : ''} ${
                props.disabled ? 'disabled' : ''
              }`}
            >
              {pretype}
            </div>
          )}
          {icon && <span className="input-icon"> {icon}</span>}
          <Field
            className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''} ${
              pretype ? 'border-left-none' : ''
            } ${icon ? 'input-with-icon' : ''}`}
            id={name}
            {...inputProps}
            {...field}
          />
        </div>
        {maxCharCount && (
          <div className={`max-limit ${meta.error ? '--invalid' : ''}`}>
            ({charCount}/{maxCharCount})
          </div>
        )}
        {helper && <p className="text-muted tw-m-0 tw-p-1">{helper}</p>}
        {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
      </div>
    </div>
  );
};

export default TextField;
